import React from 'react';
import { StepProps } from '../MultiStepModal';

/**
 * Site / job context sent with certificate requests so engineers see where to attend
 * and which job reference to use (e.g. CP17 breakdown visits).
 */
export default function CertificateRequestSiteJobStep({ data, onDataChange }: StepProps) {
  const jobNumber = String(data.jobNumber || '');
  const siteName = String(data.siteName || '');
  const siteAddress = String(data.siteAddress || '');
  const sitePostcode = String(data.sitePostcode || '');

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Site &amp; job details</h3>
        <p className="step-form-subtitle">
          Tell the engineer which property this certificate applies to and your internal job reference.
        </p>
      </div>

      <div className="step-form-content space-y-3">
        <div className="form-group">
          <label className="form-label">Job number *</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g. JOB-1042"
            value={jobNumber}
            onChange={(e) => onDataChange({ jobNumber: e.target.value })}
            autoComplete="off"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Site / property name</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g. Riverside Academy — Boiler room"
            value={siteName}
            onChange={(e) => onDataChange({ siteName: e.target.value })}
            autoComplete="off"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Site address *</label>
          <input
            type="text"
            className="form-input"
            placeholder="Where the engineer should attend"
            value={siteAddress}
            onChange={(e) => onDataChange({ siteAddress: e.target.value })}
            autoComplete="street-address"
          />
          <p className="mt-1 text-xs text-[#686E6C]">
            Can differ from the customer billing address (next step).
          </p>
        </div>

        <div className="form-group">
          <label className="form-label">Site postcode</label>
          <input
            type="text"
            className="form-input"
            placeholder="e.g. GU14 7QU"
            value={sitePostcode}
            onChange={(e) => onDataChange({ sitePostcode: e.target.value })}
            autoComplete="postal-code"
          />
        </div>
      </div>
    </div>
  );
}
